@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.cost-review-modal {
  width: 750px;
}

.modal-body {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  padding: @space-16;
  min-height: 176px;
}
